var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66947 3.62024C4 4.24049 4 5.23876 4 7.23529V16.7647C4 18.7612 4   19.7595 4.66947 20.3798C5.33894 21 6.41644 21 8.57143 21H15.4286C17.5836 21 18.6611 21 19.3305 20.3798C20 19.7595 20   18.7612 20 16.7647V7.23529C20 5.23876 20 4.24049 19.3305 3.62024C18.6611 3 17.5836 3 15.4286 3H8.57143C6.41644 3 5.33894   3 4.66947 3.62024ZM8.57143 7.23529C7.94025 7.23529 7.42857 7.70935 7.42857 8.29412C7.42857 8.87889 7.94025 9.35294   8.57143 9.35294H15.4286C16.0598 9.35294 16.5714 8.87889 16.5714 8.29412C16.5714 7.70935 16.0598 7.23529 15.4286   7.23529H8.57143ZM8.57143 11.4706C7.94025 11.4706 7.42857 11.9446 7.42857 12.5294C7.42857 13.1142 7.94025 13.5882   8.57143 13.5882H15.4286C16.0598 13.5882 16.5714 13.1142 16.5714 12.5294C16.5714 11.9446 16.0598 11.4706 15.4286   11.4706H8.57143ZM8.57143 15.7059C7.94025 15.7059 7.42857 16.1799 7.42857 16.7647C7.42857 17.3495 7.94025 17.8235   8.57143 17.8235H13.1429C13.774 17.8235 14.2857 17.3495 14.2857 16.7647C14.2857 16.1799 13.774 15.7059 13.1429   15.7059H8.57143Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.c8f91f425bc730cc10a89495ad5a177f.svg";
export { ForwardRef as ReactComponent };